import { ToggleButtonGroup, ToggleButton as MuiToggleButton, ToggleButtonGroupProps, FormControl, FormLabel, FormLabelProps, Stack } from "@mui/material"
import { Controller, UseControllerProps } from "react-hook-form";
import { get } from "radash";

export type ToggleButtonsProps = ToggleButtonGroupProps & UseControllerProps<any> & {
	options: { value: string, label: string }[];
	label: string;
	orientation?: "vertical" | "horizontal";
	labelProps?: FormLabelProps;
	spacing?: number;
}

const ToggleButtons = (props: ToggleButtonsProps) => {
	const { control, name, options, label, labelProps, orientation, spacing, ...rest } = props;

	return (
		<Controller
			name={name}
			control={control}
			render={({ field, formState: state }) => (
				<FormControl error={!!get(state.errors, name)}>
					<Stack spacing={spacing || 1}>
						<FormLabel id="radio-group-label" {...labelProps}>{label}</FormLabel>
						<ToggleButtonGroup
							size="large"
							value={field.value}
							onChange={field.onChange}
							exclusive
							orientation={orientation}
							{...rest}
						>
							{options.map((option: { value: string, label: string }) => (
								<MuiToggleButton key={`${name}-${option.value}`} value={option.value}>{option.label}</MuiToggleButton>
							))}
						</ToggleButtonGroup>
					</Stack>
				</FormControl>
			)}
		/>
	)
}

export default ToggleButtons;